<template lang="pug">
  .socials__preloader
    img(src="@/assets/img/global/loader.gif" alt="")
</template>

<script>
export default {
  name: 'SocialsPreloader'
}
</script>
